import { render, staticRenderFns } from "./FilterAccordionHeading.vue?vue&type=template&id=271ad629&scoped=true"
import script from "./FilterAccordionHeading.vue?vue&type=script&lang=ts"
export * from "./FilterAccordionHeading.vue?vue&type=script&lang=ts"
import style0 from "./FilterAccordionHeading.vue?vue&type=style&index=0&id=271ad629&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271ad629",
  null
  
)

export default component.exports